import { useTranslation } from 'react-i18next'
import { Paginator, type PaginatorPageChangeEvent } from 'primereact/paginator'

export interface CardPaginatorProps {
  /** Görünen ilk kaydın sırası (0 tabanlı) — PrimeReact `first`. */
  first: number
  /** Sayfa boyutu. */
  rows: number
  /** Süzgeçten geçmiş TOPLAM kayıt sayısı (açık sayfanınki değil). */
  totalRecords: number
  /** Yeni `first` değeri; sayfa boyutu bu paginatörde değişmez (dropdown yok). */
  onPage: (first: number) => void
}

/**
 * Dar ekranda **kart listesinin altına** çizilen derli toplu sayfalama çubuğu (Reuse Mandate).
 *
 * <p>Kartlarda tablo başlığı/araç çubuğu yoktur; bu yüzden paginatör de sadeleşir: yalnız
 * <b>önceki / sayfa raporu / sonraki</b>. Satır-sayfa dropdown'ı bilinçli olarak <b>yoktur</b> —
 * telefon genişliğinde üç kontrol zaten satırı doldurur.
 *
 * <p>Bu kalıp ekranlara tek tek kopyalanmış hâlde duruyordu (`PrefixesPage`, `DeadlineRequestsPage`,
 * `SentEmailsAdminPage`, `TicketTable`, `ActionsListPanel` …): 23.09.2026'da **11 dosyada 12 kopya**
 * sayıldı (`TemplateParametersAdminPage` deseni iki kez kullanıyor). Yeni ekranlar buradan alır; eski
 * çağıranlar dokunulduklarında buraya taşınabilir — kopyalar çoğaldıkça `template` ve `className`
 * sessizce ayrışıyordu.
 *
 * <p>Sayfa boyutu <b>çağıranda sabittir</b>: dropdown olmadığı için `onPageChange` olayının `rows`
 * alanı hiçbir zaman değişmez, dolayısıyla geri verilmez (kopyalarda bu değer boşuna state'e
 * yazılıyordu).
 */
export default function CardPaginator({ first, rows, totalRecords, onPage }: CardPaginatorProps) {
  const { t } = useTranslation()

  return (
    <Paginator
      first={first}
      rows={rows}
      totalRecords={totalRecords}
      onPageChange={(e: PaginatorPageChangeEvent) => onPage(e.first)}
      template="PrevPageLink CurrentPageReport NextPageLink"
      currentPageReportTemplate={t('common.pageReport')}
      className="ui-cards-paginator"
    />
  )
}
